"use client";
import React, { Suspense, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SkeletonTheme } from "react-loading-skeleton";
import { Toaster } from "react-hot-toast";

// Dynamic import for IntlProvider
import { IntlProvider } from "react-intl";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import StickyWhatsapp from "./StickyWhatsapp/StickyWhatsapp";
import WhatsappModal from "./WhatsappModal/WhatsappModal";
import { closeModal} from "@/slice/whatsappModalSlice";
//Import WhatsappModal

const LanguageWrapper = ({ children, footerNavbarData, treatmentsData }) => {
  const lang = useSelector((state) => state.locale.locale);
  const [messages, setMessages] = useState(null);
  const {isOpen, headline} = useSelector((state) => state.whatsappModal);
  const dispatch = useDispatch();
  const navbarFooterData = footerNavbarData;
  const isLoading = false;

  useEffect(() => {
    const loadLocaleData = async () => {
      let localeModule;
      switch (lang) {
        case "en":
          localeModule = await import("../components/locales/en/common.json");
          break;
        case "ar":
          localeModule = await import("../components/locales/ar/common.json");
          break;
        case "fr":
          localeModule = await import("../components/locales/fr/common.json");
          break;
        case "ru":
          localeModule = await import("../components/locales/ru/common.json");
          break;
        case "tl":
          localeModule = await import("../components/locales/tl/common.json");
          break;
        case "id":
          localeModule = await import("../components/locales/id/common.json");
          break;
        case "ms":
          localeModule = await import("../components/locales/ms/common.json");
          break;
        case "bn":
          localeModule = await import("../components/locales/bn/common.json");
          break;
        case "am":
          localeModule = await import("../components/locales/am/common.json");
          break;
        case "kz":
          localeModule = await import("../components/locales/kz/common.json");
          break;
        case "uz":
          localeModule = await import("../components/locales/uz/common.json");
          break;
        case "tz":
          localeModule = await import("../components/locales/tz/common.json");
          break;
        case "ha":
          localeModule = await import("../components/locales/ha/common.json");
          break;
        case "ja":
          localeModule = await import("../components/locales/ja/common.json");
          break;
        case "es":
          localeModule = await import("../components/locales/es/common.json");
          break;
        case "pt":
          localeModule = await import("../components/locales/pt/common.json");
          break;
        default:
          localeModule = await import("../components/locales/en/common.json");
      }
      // Handle both default export and direct object
      setMessages(localeModule.default || localeModule);
    };

    loadLocaleData();
  }, [lang]);

  if (!messages) {
    return;
  }

  return (
    <div>
      <IntlProvider
        locale={lang}
        messages={messages}
        onError={(err) => {
          if (err.code === "MISSING_TRANSLATION") {
            return;
          }
          console.error(err);
        }}
      >
        {/* Dynamically loaded Navbar */}
        <Suspense fallback={<div>Loading Navbar...</div>}>
          {!isLoading && navbarFooterData?.data && (
            <Navbar data={navbarFooterData} treatmentsData={treatmentsData} />
          )}
        </Suspense>

        <SkeletonTheme baseColor="#202020" highlightColor="#444">
          <div>{children}</div>
        </SkeletonTheme>

        {/* Toaster for notifications */}
        <Toaster />

        {/* Dynamically loaded Footer */}
        <Suspense fallback={<div>Loading Footer...</div>}>
          {!isLoading && navbarFooterData?.data && <Footer data={navbarFooterData} />}
        </Suspense>

        {/* Sticky WhatsApp CTA */}
        <StickyWhatsapp />

        {/* Whatsapp Modal */}
        <WhatsappModal
          isOpen={isOpen}
          headline={headline}
          onClose={()=>dispatch(closeModal())}
        />
      </IntlProvider>
    </div>
  );
};

export default LanguageWrapper;
